function InlineSpinner() {
  return (
    <div className="relative py-16">
      <svg className="ai-loader ai-loader--centered" viewBox="0 0 50 50" aria-hidden="true">
        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
      </svg>
    </div>
  )
}

export default InlineSpinner
